import { IApiResponse } from "../../../../@types/api-response.type"
import { ISoftSkillsDto } from "../../../../@types/curriculum.type"
import { Api } from "../../ApiConfig"
import { ApiException } from "../../ApiException"
import { getErrorMessage } from "../../../../utils/utils"

export const getAllSoftSkillReference = async () : Promise<ISoftSkillsDto[]> => {
  try {
      const { data } = await Api.get<IApiResponse<ISoftSkillsDto[]>>(`/api/SoftSkill/GetAllSoftSkillReference`)
      return data.result
  } catch (error) {
      throw new ApiException(getErrorMessage(error, 'Erro ao consultar Soft Skills'))
  }  
}
